module.exports = __webpack_public_path__ + "static/img/logo.4e4619a1.png";